import React from 'react' 
import { Route, Routes } from 'react-router-dom'; 
import AllService from '../service/AllService';

const ServiceRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/all-service" element={<AllService />} /> 
            </Routes>
        </>
    )
}

export default ServiceRoutes;